import { Platform, useWindowDimensions } from 'react-native';

import { layout, type AppLayoutMode } from '../core/theme/layout';

export type AppLayout = {
  mode: AppLayoutMode;
  width: number;
  /** Show left sidebar nav (web desktop). */
  sidebar: boolean;
  /** Dashboard widget columns: 1 or 2. */
  columns: 1 | 2;
  /** Horizontal padding for screen content. */
  contentPadding: number;
  /** Left offset when sidebar is visible. */
  sidebarWidth: number;
  /** Gap between widget grid cells. */
  widgetGap: number;
};

/** Responsive layout flags — web-only breakpoints; native always returns single column. */
export function useAppLayout(): AppLayout {
  const { width } = useWindowDimensions();

  if (Platform.OS !== 'web') {
    return {
      mode: 'native',
      width,
      sidebar: false,
      columns: 1,
      contentPadding: 16,
      sidebarWidth: 0,
      widgetGap: 16,
    };
  }

  if (width >= layout.webTwoColumnBreakpoint) {
    return {
      mode: 'webWide',
      width,
      sidebar: true,
      columns: 2,
      contentPadding: layout.webContentPadding,
      sidebarWidth: layout.webSidebarWidth,
      widgetGap: 20,
    };
  }

  if (width >= layout.webSidebarBreakpoint) {
    return {
      mode: 'webSidebar',
      width,
      sidebar: true,
      columns: 1,
      contentPadding: layout.webContentPadding,
      sidebarWidth: layout.webSidebarWidth,
      widgetGap: 16,
    };
  }

  return {
    mode: 'webCompact',
    width,
    sidebar: false,
    columns: 1,
    contentPadding: layout.webGutter,
    sidebarWidth: 0,
    widgetGap: 16,
  };
}
